import React, { useEffect } from 'react';
import { Row } from 'react-bootstrap';

const DaysSwitcher = ({
                          totalWords,
                          selectedDays,
                          setSelectedDays,
                          setCurrency,
                          displayOffsetDays = 0, // новое: визуальный сдвиг (например, +10)
                      }) => {
    const getDaysForWords = (totalWords) => {
        if (totalWords >= 150000) return [7, 6, 5, 4, 3, 2, 1];
        if (totalWords >= 100000) return [6, 5, 4, 3, 2, 1];
        if (totalWords >= 60000)  return [6, 5, 4, 3, 2, 1];
        if (totalWords >= 40000)  return [5, 4, 3, 2, 1];
        if (totalWords >= 20000)  return [4, 3, 2, 1];
        return [3, 2, 1];
    };

    const days = getDaysForWords(totalWords);
    const HiDay = days[0];

    const calculateCurrency = (selDays) => {
        const dayDifference = HiDay - selDays;
        switch (dayDifference) {
            case 1: return 100;
            case 2: return 200;
            case 3: return 300;
            default: return 0;
        }
    };

    // считаем надбавку от реальных выбранных дней (без сдвига доставки)
    useEffect(() => {
        setCurrency(calculateCurrency(selectedDays));
    }, [selectedDays, setCurrency]);

    // при смене объёма слов — сбрасываем выбранный день на максимальный
    useEffect(() => {
        setSelectedDays(days[0]);
    }, [totalWords]);

    return (
        <Row className="justify-content-center mb-3">
            <div className="btn-group flex-wrap" role="group" aria-label="Days Selection">
                {days.slice(0, 4).map((day) => {
                    const labelDay = day + Number(displayOffsetDays || 0); // показываем +10, если нужно
                    return (
                        <React.Fragment key={day}>
                            <input
                                type="radio"
                                className="btn-check"
                                name="readingDays"
                                id={`day-${day}`}
                                autoComplete="off"
                                checked={selectedDays === day}
                                onChange={() => setSelectedDays(day)}
                            />
                            <label
                                className={`btn btn-sm btn-outline-success ${selectedDays === day ? 'active' : ''}`}
                                htmlFor={`day-${day}`}
                                style={{ minWidth: '80px', textAlign: 'center' }}
                                title={
                                    displayOffsetDays
                                        ? `${labelDay} days total (includes ${displayOffsetDays} days for delivery)`
                                        : `${labelDay} days`
                                }
                            >
                                {labelDay} Day{labelDay > 1 ? 's' : ''}
                            </label>
                        </React.Fragment>
                    );
                })}
            </div>
        </Row>
    );
};

export default DaysSwitcher;
